import { forwardRef } from "react";
import { Link, NavLink } from "react-router-dom";
import { useSeason } from "../../context/SeasonContext";
function scopedTarget(to, withSeason) {
  if (typeof to !== "string" || !to.startsWith("/") || to.startsWith("//"))
    return to;
  if (new URL(to, window.location.origin).searchParams.has("season")) return to;
  return withSeason(to);
}
export const SeasonLink = forwardRef(function SeasonLink(
  { to, ...props },
  ref,
) {
  const { withSeason } = useSeason();
  return <Link ref={ref} to={scopedTarget(to, withSeason)} {...props} />;
});
export const SeasonNavLink = forwardRef(function SeasonNavLink(
  { to, ...props },
  ref,
) {
  const { withSeason } = useSeason();
  return <NavLink ref={ref} to={scopedTarget(to, withSeason)} {...props} />;
});
